import PropTypes from 'prop-types';
import React from 'react';
import * as Ui from './AnimatedGradientSpinner.styles';

const AnimatedGradientSpinner = ({ size, colors, speed }) => (
  <Ui.SpinnerWrapper
    $size={size}
    $colors={colors.length > 1 ? [...colors, colors[0]] : colors}
    $speed={speed}
  />
);

AnimatedGradientSpinner.propTypes = {
  size: PropTypes.number,
  colors: PropTypes.arrayOf(PropTypes.string),
  speed: PropTypes.number,
};

AnimatedGradientSpinner.defaultProps = {
  size: 50,
  colors: ['#f82fc6', '#5a4ff9', '#ff923e'],
  speed: 1,
};

export default AnimatedGradientSpinner;
